import { z } from 'zod';
import { activityKindSchema } from './content.js';
import { learnerProfileSchema } from './learner.js';
import { capabilityLevelSchema, programModuleSchema } from './program.js';
export const homeSummarySchema = z.object({
    learner: learnerProfileSchema,
    position: z.object({
        currentModule: z.number().int().min(1),
        totalModules: z.number().int().min(1),
        module: programModuleSchema,
        completionPercent: z.number().min(0).max(100),
    }),
    nextActivity: z.object({
        id: z.uuid().nullable(),
        kind: activityKindSchema,
        code: z.string(),
        title: z.string(),
        description: z.string(),
        mioNote: z.string(),
    }),
    week: z.object({
        minutesSpent: z.number().int().min(0),
        targetMinutes: z.number().int().min(0),
    }),
    capabilities: z.array(z.object({
        id: z.string(),
        title: z.string(),
        level: capabilityLevelSchema,
    })),
    field: z.object({
        locked: z.boolean(),
        opensWeek: z.number().int().min(1),
        clientName: z.string(),
    }),
});
